var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_list_down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 24,
    height: 24,
    fill: "rgba(255,0,0,0.1)",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_37",
    "data-name": "\\uD328\\uC2A4 37",
    transform: "translate(7.899 9.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8126",
    "data-name": "\\uD328\\uC2A4 8126",
    d: "M36.3,135.592a.6.6,0,0,1-.407-.159l-4-3.692a.6.6,0,0,1,.814-.882l3.593,3.317,3.593-3.317a.6.6,0,0,1,.814.882l-4,3.692A.6.6,0,0,1,36.3,135.592Z",
    transform: "translate(-31.7 -130.7)",
    fill: "#484848"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListDown);
export default __webpack_public_path__ + "static/media/icon_list_down.f48a3bdde36d3fb5d32b5f9d62b09353.svg";
export { ForwardRef as ReactComponent };